module.exports = [
	{
		"x": 35,
		"y": 0
	},
	{
		"x": 35,
		"y": 1
	},
	{
		"x": 35,
		"y": 2
	},
	{
		"x": 36,
		"y": 2
	},
	{
		"x": 34,
		"y": 3
	},
	{
		"x": 35,
		"y": 3
	},
	{
		"x": 36,
		"y": 3
	},
	{
		"x": 34,
		"y": 4
	},
	{
		"x": 35,
		"y": 4
	},
	{
		"x": 36,
		"y": 4
	},
	{
		"x": 35,
		"y": 5
	},
	{
		"x": 36,
		"y": 5
	},
	{
		"x": 35,
		"y": 6
	},
	{
		"x": 36,
		"y": 6
	},
	{
		"x": 35,
		"y": 7
	},
	{
		"x": 36,
		"y": 7
	},
	{
		"x": 37,
		"y": 7
	},
	{
		"x": 35,
		"y": 8
	},
	{
		"x": 36,
		"y": 8
	},
	{
		"x": 37,
		"y": 8
	},
	{
		"x": 33,
		"y": 9
	},
	{
		"x": 35,
		"y": 9
	},
	{
		"x": 36,
		"y": 9
	},
	{
		"x": 37,
		"y": 9
	},
	{
		"x": 32,
		"y": 10
	},
	{
		"x": 33,
		"y": 10
	},
	{
		"x": 34,
		"y": 10
	},
	{
		"x": 35,
		"y": 10
	},
	{
		"x": 36,
		"y": 10
	},
	{
		"x": 37,
		"y": 10
	},
	{
		"x": 32,
		"y": 11
	},
	{
		"x": 33,
		"y": 11
	},
	{
		"x": 34,
		"y": 11
	},
	{
		"x": 35,
		"y": 11
	},
	{
		"x": 36,
		"y": 11
	},
	{
		"x": 37,
		"y": 11
	},
	{
		"x": 38,
		"y": 11
	},
	{
		"x": 32,
		"y": 12
	},
	{
		"x": 33,
		"y": 12
	},
	{
		"x": 34,
		"y": 12
	},
	{
		"x": 35,
		"y": 12
	},
	{
		"x": 36,
		"y": 12
	},
	{
		"x": 37,
		"y": 12
	},
	{
		"x": 38,
		"y": 12
	},
	{
		"x": 33,
		"y": 13
	},
	{
		"x": 34,
		"y": 13
	},
	{
		"x": 35,
		"y": 13
	},
	{
		"x": 36,
		"y": 13
	},
	{
		"x": 37,
		"y": 13
	},
	{
		"x": 38,
		"y": 13
	},
	{
		"x": 33,
		"y": 14
	},
	{
		"x": 34,
		"y": 14
	},
	{
		"x": 35,
		"y": 14
	},
	{
		"x": 36,
		"y": 14
	},
	{
		"x": 37,
		"y": 14
	},
	{
		"x": 38,
		"y": 14
	},
	{
		"x": 32,
		"y": 15
	},
	{
		"x": 33,
		"y": 15
	},
	{
		"x": 34,
		"y": 15
	},
	{
		"x": 35,
		"y": 15
	},
	{
		"x": 36,
		"y": 15
	},
	{
		"x": 37,
		"y": 15
	},
	{
		"x": 38,
		"y": 15
	},
	{
		"x": 32,
		"y": 16
	},
	{
		"x": 33,
		"y": 16
	},
	{
		"x": 34,
		"y": 16
	},
	{
		"x": 35,
		"y": 16
	},
	{
		"x": 36,
		"y": 16
	},
	{
		"x": 37,
		"y": 16
	},
	{
		"x": 38,
		"y": 16
	},
	{
		"x": 32,
		"y": 17
	},
	{
		"x": 33,
		"y": 17
	},
	{
		"x": 34,
		"y": 17
	},
	{
		"x": 35,
		"y": 17
	},
	{
		"x": 36,
		"y": 17
	},
	{
		"x": 37,
		"y": 17
	},
	{
		"x": 38,
		"y": 17
	},
	{
		"x": 31,
		"y": 18
	},
	{
		"x": 32,
		"y": 18
	},
	{
		"x": 33,
		"y": 18
	},
	{
		"x": 34,
		"y": 18
	},
	{
		"x": 35,
		"y": 18
	},
	{
		"x": 36,
		"y": 18
	},
	{
		"x": 37,
		"y": 18
	},
	{
		"x": 38,
		"y": 18
	},
	{
		"x": 39,
		"y": 18
	},
	{
		"x": 32,
		"y": 19
	},
	{
		"x": 33,
		"y": 19
	},
	{
		"x": 34,
		"y": 19
	},
	{
		"x": 35,
		"y": 19
	},
	{
		"x": 36,
		"y": 19
	},
	{
		"x": 37,
		"y": 19
	},
	{
		"x": 38,
		"y": 19
	},
	{
		"x": 39,
		"y": 19
	},
	{
		"x": 40,
		"y": 19
	},
	{
		"x": 32,
		"y": 20
	},
	{
		"x": 33,
		"y": 20
	},
	{
		"x": 34,
		"y": 20
	},
	{
		"x": 35,
		"y": 20
	},
	{
		"x": 36,
		"y": 20
	},
	{
		"x": 37,
		"y": 20
	},
	{
		"x": 38,
		"y": 20
	},
	{
		"x": 39,
		"y": 20
	},
	{
		"x": 40,
		"y": 20
	},
	{
		"x": 41,
		"y": 20
	},
	{
		"x": 32,
		"y": 21
	},
	{
		"x": 33,
		"y": 21
	},
	{
		"x": 34,
		"y": 21
	},
	{
		"x": 35,
		"y": 21
	},
	{
		"x": 36,
		"y": 21
	},
	{
		"x": 37,
		"y": 21
	},
	{
		"x": 38,
		"y": 21
	},
	{
		"x": 39,
		"y": 21
	},
	{
		"x": 40,
		"y": 21
	},
	{
		"x": 41,
		"y": 21
	},
	{
		"x": 42,
		"y": 21
	},
	{
		"x": 32,
		"y": 22
	},
	{
		"x": 33,
		"y": 22
	},
	{
		"x": 34,
		"y": 22
	},
	{
		"x": 35,
		"y": 22
	},
	{
		"x": 36,
		"y": 22
	},
	{
		"x": 37,
		"y": 22
	},
	{
		"x": 38,
		"y": 22
	},
	{
		"x": 39,
		"y": 22
	},
	{
		"x": 40,
		"y": 22
	},
	{
		"x": 41,
		"y": 22
	},
	{
		"x": 42,
		"y": 22
	},
	{
		"x": 43,
		"y": 22
	},
	{
		"x": 33,
		"y": 23
	},
	{
		"x": 34,
		"y": 23
	},
	{
		"x": 35,
		"y": 23
	},
	{
		"x": 36,
		"y": 23
	},
	{
		"x": 37,
		"y": 23
	},
	{
		"x": 38,
		"y": 23
	},
	{
		"x": 39,
		"y": 23
	},
	{
		"x": 40,
		"y": 23
	},
	{
		"x": 41,
		"y": 23
	},
	{
		"x": 42,
		"y": 23
	},
	{
		"x": 43,
		"y": 23
	},
	{
		"x": 44,
		"y": 23
	},
	{
		"x": 33,
		"y": 24
	},
	{
		"x": 34,
		"y": 24
	},
	{
		"x": 35,
		"y": 24
	},
	{
		"x": 36,
		"y": 24
	},
	{
		"x": 37,
		"y": 24
	},
	{
		"x": 38,
		"y": 24
	},
	{
		"x": 39,
		"y": 24
	},
	{
		"x": 40,
		"y": 24
	},
	{
		"x": 41,
		"y": 24
	},
	{
		"x": 42,
		"y": 24
	},
	{
		"x": 43,
		"y": 24
	},
	{
		"x": 44,
		"y": 24
	},
	{
		"x": 45,
		"y": 24
	},
	{
		"x": 32,
		"y": 25
	},
	{
		"x": 33,
		"y": 25
	},
	{
		"x": 34,
		"y": 25
	},
	{
		"x": 35,
		"y": 25
	},
	{
		"x": 36,
		"y": 25
	},
	{
		"x": 37,
		"y": 25
	},
	{
		"x": 38,
		"y": 25
	},
	{
		"x": 39,
		"y": 25
	},
	{
		"x": 40,
		"y": 25
	},
	{
		"x": 41,
		"y": 25
	},
	{
		"x": 42,
		"y": 25
	},
	{
		"x": 43,
		"y": 25
	},
	{
		"x": 44,
		"y": 25
	},
	{
		"x": 45,
		"y": 25
	},
	{
		"x": 32,
		"y": 26
	},
	{
		"x": 33,
		"y": 26
	},
	{
		"x": 34,
		"y": 26
	},
	{
		"x": 35,
		"y": 26
	},
	{
		"x": 36,
		"y": 26
	},
	{
		"x": 37,
		"y": 26
	},
	{
		"x": 38,
		"y": 26
	},
	{
		"x": 39,
		"y": 26
	},
	{
		"x": 40,
		"y": 26
	},
	{
		"x": 41,
		"y": 26
	},
	{
		"x": 42,
		"y": 26
	},
	{
		"x": 43,
		"y": 26
	},
	{
		"x": 32,
		"y": 27
	},
	{
		"x": 33,
		"y": 27
	},
	{
		"x": 34,
		"y": 27
	},
	{
		"x": 35,
		"y": 27
	},
	{
		"x": 36,
		"y": 27
	},
	{
		"x": 37,
		"y": 27
	},
	{
		"x": 38,
		"y": 27
	},
	{
		"x": 39,
		"y": 27
	},
	{
		"x": 40,
		"y": 27
	},
	{
		"x": 41,
		"y": 27
	},
	{
		"x": 42,
		"y": 27
	},
	{
		"x": 43,
		"y": 27
	},
	{
		"x": 32,
		"y": 28
	},
	{
		"x": 33,
		"y": 28
	},
	{
		"x": 34,
		"y": 28
	},
	{
		"x": 35,
		"y": 28
	},
	{
		"x": 36,
		"y": 28
	},
	{
		"x": 37,
		"y": 28
	},
	{
		"x": 38,
		"y": 28
	},
	{
		"x": 39,
		"y": 28
	},
	{
		"x": 40,
		"y": 28
	},
	{
		"x": 41,
		"y": 28
	},
	{
		"x": 42,
		"y": 28
	},
	{
		"x": 43,
		"y": 28
	},
	{
		"x": 32,
		"y": 29
	},
	{
		"x": 33,
		"y": 29
	},
	{
		"x": 34,
		"y": 29
	},
	{
		"x": 35,
		"y": 29
	},
	{
		"x": 36,
		"y": 29
	},
	{
		"x": 37,
		"y": 29
	},
	{
		"x": 38,
		"y": 29
	},
	{
		"x": 39,
		"y": 29
	},
	{
		"x": 40,
		"y": 29
	},
	{
		"x": 41,
		"y": 29
	},
	{
		"x": 42,
		"y": 29
	},
	{
		"x": 31,
		"y": 30
	},
	{
		"x": 32,
		"y": 30
	},
	{
		"x": 33,
		"y": 30
	},
	{
		"x": 34,
		"y": 30
	},
	{
		"x": 35,
		"y": 30
	},
	{
		"x": 36,
		"y": 30
	},
	{
		"x": 37,
		"y": 30
	},
	{
		"x": 38,
		"y": 30
	},
	{
		"x": 39,
		"y": 30
	},
	{
		"x": 40,
		"y": 30
	},
	{
		"x": 41,
		"y": 30
	},
	{
		"x": 31,
		"y": 31
	},
	{
		"x": 32,
		"y": 31
	},
	{
		"x": 33,
		"y": 31
	},
	{
		"x": 34,
		"y": 31
	},
	{
		"x": 35,
		"y": 31
	},
	{
		"x": 36,
		"y": 31
	},
	{
		"x": 37,
		"y": 31
	},
	{
		"x": 38,
		"y": 31
	},
	{
		"x": 39,
		"y": 31
	},
	{
		"x": 31,
		"y": 32
	},
	{
		"x": 32,
		"y": 32
	},
	{
		"x": 33,
		"y": 32
	},
	{
		"x": 34,
		"y": 32
	},
	{
		"x": 37,
		"y": 32
	},
	{
		"x": 38,
		"y": 32
	},
	{
		"x": 39,
		"y": 32
	},
	{
		"x": 31,
		"y": 33
	},
	{
		"x": 32,
		"y": 33
	},
	{
		"x": 33,
		"y": 33
	},
	{
		"x": 34,
		"y": 33
	},
	{
		"x": 37,
		"y": 33
	},
	{
		"x": 38,
		"y": 33
	},
	{
		"x": 39,
		"y": 33
	},
	{
		"x": 40,
		"y": 33
	},
	{
		"x": 31,
		"y": 34
	},
	{
		"x": 32,
		"y": 34
	},
	{
		"x": 33,
		"y": 34
	},
	{
		"x": 38,
		"y": 34
	},
	{
		"x": 39,
		"y": 34
	},
	{
		"x": 40,
		"y": 34
	},
	{
		"x": 31,
		"y": 35
	},
	{
		"x": 32,
		"y": 35
	},
	{
		"x": 33,
		"y": 35
	},
	{
		"x": 38,
		"y": 35
	},
	{
		"x": 39,
		"y": 35
	},
	{
		"x": 40,
		"y": 35
	},
	{
		"x": 30,
		"y": 36
	},
	{
		"x": 31,
		"y": 36
	},
	{
		"x": 32,
		"y": 36
	},
	{
		"x": 33,
		"y": 36
	},
	{
		"x": 39,
		"y": 36
	},
	{
		"x": 40,
		"y": 36
	},
	{
		"x": 41,
		"y": 36
	},
	{
		"x": 30,
		"y": 37
	},
	{
		"x": 31,
		"y": 37
	},
	{
		"x": 32,
		"y": 37
	},
	{
		"x": 39,
		"y": 37
	},
	{
		"x": 40,
		"y": 37
	},
	{
		"x": 41,
		"y": 37
	},
	{
		"x": 30,
		"y": 38
	},
	{
		"x": 31,
		"y": 38
	},
	{
		"x": 32,
		"y": 38
	},
	{
		"x": 39,
		"y": 38
	},
	{
		"x": 40,
		"y": 38
	},
	{
		"x": 41,
		"y": 38
	},
	{
		"x": 30,
		"y": 39
	},
	{
		"x": 31,
		"y": 39
	},
	{
		"x": 32,
		"y": 39
	},
	{
		"x": 40,
		"y": 39
	},
	{
		"x": 41,
		"y": 39
	},
	{
		"x": 30,
		"y": 40
	},
	{
		"x": 31,
		"y": 40
	},
	{
		"x": 32,
		"y": 40
	},
	{
		"x": 40,
		"y": 40
	},
	{
		"x": 41,
		"y": 40
	},
	{
		"x": 30,
		"y": 41
	},
	{
		"x": 31,
		"y": 41
	},
	{
		"x": 40,
		"y": 41
	},
	{
		"x": 41,
		"y": 41
	},
	{
		"x": 29,
		"y": 42
	},
	{
		"x": 30,
		"y": 42
	},
	{
		"x": 31,
		"y": 42
	},
	{
		"x": 40,
		"y": 42
	},
	{
		"x": 41,
		"y": 42
	},
	{
		"x": 29,
		"y": 43
	},
	{
		"x": 30,
		"y": 43
	},
	{
		"x": 31,
		"y": 43
	},
	{
		"x": 40,
		"y": 43
	},
	{
		"x": 41,
		"y": 43
	},
	{
		"x": 27,
		"y": 44
	},
	{
		"x": 28,
		"y": 44
	},
	{
		"x": 29,
		"y": 44
	},
	{
		"x": 30,
		"y": 44
	},
	{
		"x": 31,
		"y": 44
	},
	{
		"x": 39,
		"y": 44
	},
	{
		"x": 40,
		"y": 44
	},
	{
		"x": 41,
		"y": 44
	},
	{
		"x": 42,
		"y": 44
	},
	{
		"x": 0,
		"y": 45
	},
	{
		"x": 1,
		"y": 45
	},
	{
		"x": 2,
		"y": 45
	},
	{
		"x": 3,
		"y": 45
	},
	{
		"x": 4,
		"y": 45
	},
	{
		"x": 5,
		"y": 45
	},
	{
		"x": 6,
		"y": 45
	},
	{
		"x": 7,
		"y": 45
	},
	{
		"x": 8,
		"y": 45
	},
	{
		"x": 9,
		"y": 45
	},
	{
		"x": 10,
		"y": 45
	},
	{
		"x": 11,
		"y": 45
	},
	{
		"x": 12,
		"y": 45
	},
	{
		"x": 13,
		"y": 45
	},
	{
		"x": 14,
		"y": 45
	},
	{
		"x": 15,
		"y": 45
	},
	{
		"x": 16,
		"y": 45
	},
	{
		"x": 17,
		"y": 45
	},
	{
		"x": 18,
		"y": 45
	},
	{
		"x": 19,
		"y": 45
	},
	{
		"x": 20,
		"y": 45
	},
	{
		"x": 21,
		"y": 45
	},
	{
		"x": 22,
		"y": 45
	},
	{
		"x": 23,
		"y": 45
	},
	{
		"x": 24,
		"y": 45
	},
	{
		"x": 25,
		"y": 45
	},
	{
		"x": 26,
		"y": 45
	},
	{
		"x": 27,
		"y": 45
	},
	{
		"x": 28,
		"y": 45
	},
	{
		"x": 29,
		"y": 45
	},
	{
		"x": 30,
		"y": 45
	},
	{
		"x": 31,
		"y": 45
	},
	{
		"x": 32,
		"y": 45
	},
	{
		"x": 33,
		"y": 45
	},
	{
		"x": 34,
		"y": 45
	},
	{
		"x": 35,
		"y": 45
	},
	{
		"x": 36,
		"y": 45
	},
	{
		"x": 37,
		"y": 45
	},
	{
		"x": 38,
		"y": 45
	},
	{
		"x": 39,
		"y": 45
	},
	{
		"x": 40,
		"y": 45
	},
	{
		"x": 41,
		"y": 45
	},
	{
		"x": 42,
		"y": 45
	},
	{
		"x": 43,
		"y": 45
	},
	{
		"x": 44,
		"y": 45
	},
	{
		"x": 45,
		"y": 45
	},
	{
		"x": 46,
		"y": 45
	},
	{
		"x": 47,
		"y": 45
	},
	{
		"x": 48,
		"y": 45
	},
	{
		"x": 49,
		"y": 45
	},
	{
		"x": 50,
		"y": 45
	},
	{
		"x": 51,
		"y": 45
	},
	{
		"x": 52,
		"y": 45
	},
	{
		"x": 53,
		"y": 45
	},
	{
		"x": 54,
		"y": 45
	},
	{
		"x": 55,
		"y": 45
	},
	{
		"x": 56,
		"y": 45
	},
	{
		"x": 57,
		"y": 45
	},
	{
		"x": 58,
		"y": 45
	},
	{
		"x": 59,
		"y": 45
	},
	{
		"x": 60,
		"y": 45
	},
	{
		"x": 61,
		"y": 45
	},
	{
		"x": 62,
		"y": 45
	},
	{
		"x": 63,
		"y": 45
	},
	{
		"x": 64,
		"y": 45
	},
	{
		"x": 65,
		"y": 45
	},
	{
		"x": 66,
		"y": 45
	},
	{
		"x": 67,
		"y": 45
	},
	{
		"x": 68,
		"y": 45
	},
	{
		"x": 69,
		"y": 45
	},
	{
		"x": 70,
		"y": 45
	},
	{
		"x": 2,
		"y": 46
	},
	{
		"x": 3,
		"y": 46
	},
	{
		"x": 4,
		"y": 46
	},
	{
		"x": 5,
		"y": 46
	},
	{
		"x": 6,
		"y": 46
	},
	{
		"x": 7,
		"y": 46
	},
	{
		"x": 8,
		"y": 46
	},
	{
		"x": 9,
		"y": 46
	},
	{
		"x": 10,
		"y": 46
	},
	{
		"x": 11,
		"y": 46
	},
	{
		"x": 12,
		"y": 46
	},
	{
		"x": 13,
		"y": 46
	},
	{
		"x": 14,
		"y": 46
	},
	{
		"x": 15,
		"y": 46
	},
	{
		"x": 16,
		"y": 46
	},
	{
		"x": 17,
		"y": 46
	},
	{
		"x": 18,
		"y": 46
	},
	{
		"x": 19,
		"y": 46
	},
	{
		"x": 20,
		"y": 46
	},
	{
		"x": 21,
		"y": 46
	},
	{
		"x": 22,
		"y": 46
	},
	{
		"x": 23,
		"y": 46
	},
	{
		"x": 24,
		"y": 46
	},
	{
		"x": 25,
		"y": 46
	},
	{
		"x": 26,
		"y": 46
	},
	{
		"x": 27,
		"y": 46
	},
	{
		"x": 28,
		"y": 46
	},
	{
		"x": 29,
		"y": 46
	},
	{
		"x": 30,
		"y": 46
	},
	{
		"x": 31,
		"y": 46
	},
	{
		"x": 32,
		"y": 46
	},
	{
		"x": 33,
		"y": 46
	},
	{
		"x": 34,
		"y": 46
	},
	{
		"x": 35,
		"y": 46
	},
	{
		"x": 36,
		"y": 46
	},
	{
		"x": 37,
		"y": 46
	},
	{
		"x": 38,
		"y": 46
	},
	{
		"x": 39,
		"y": 46
	},
	{
		"x": 40,
		"y": 46
	},
	{
		"x": 41,
		"y": 46
	},
	{
		"x": 42,
		"y": 46
	},
	{
		"x": 43,
		"y": 46
	},
	{
		"x": 44,
		"y": 46
	},
	{
		"x": 45,
		"y": 46
	},
	{
		"x": 46,
		"y": 46
	},
	{
		"x": 47,
		"y": 46
	},
	{
		"x": 48,
		"y": 46
	},
	{
		"x": 49,
		"y": 46
	},
	{
		"x": 50,
		"y": 46
	},
	{
		"x": 51,
		"y": 46
	},
	{
		"x": 52,
		"y": 46
	},
	{
		"x": 53,
		"y": 46
	},
	{
		"x": 54,
		"y": 46
	},
	{
		"x": 55,
		"y": 46
	},
	{
		"x": 56,
		"y": 46
	},
	{
		"x": 57,
		"y": 46
	},
	{
		"x": 58,
		"y": 46
	},
	{
		"x": 59,
		"y": 46
	},
	{
		"x": 60,
		"y": 46
	},
	{
		"x": 61,
		"y": 46
	},
	{
		"x": 62,
		"y": 46
	},
	{
		"x": 63,
		"y": 46
	},
	{
		"x": 64,
		"y": 46
	},
	{
		"x": 65,
		"y": 46
	},
	{
		"x": 66,
		"y": 46
	},
	{
		"x": 67,
		"y": 46
	},
	{
		"x": 68,
		"y": 46
	},
	{
		"x": 3,
		"y": 47
	},
	{
		"x": 4,
		"y": 47
	},
	{
		"x": 5,
		"y": 47
	},
	{
		"x": 6,
		"y": 47
	},
	{
		"x": 7,
		"y": 47
	},
	{
		"x": 8,
		"y": 47
	},
	{
		"x": 9,
		"y": 47
	},
	{
		"x": 10,
		"y": 47
	},
	{
		"x": 11,
		"y": 47
	},
	{
		"x": 12,
		"y": 47
	},
	{
		"x": 13,
		"y": 47
	},
	{
		"x": 14,
		"y": 47
	},
	{
		"x": 15,
		"y": 47
	},
	{
		"x": 16,
		"y": 47
	},
	{
		"x": 17,
		"y": 47
	},
	{
		"x": 18,
		"y": 47
	},
	{
		"x": 19,
		"y": 47
	},
	{
		"x": 20,
		"y": 47
	},
	{
		"x": 21,
		"y": 47
	},
	{
		"x": 22,
		"y": 47
	},
	{
		"x": 23,
		"y": 47
	},
	{
		"x": 24,
		"y": 47
	},
	{
		"x": 25,
		"y": 47
	},
	{
		"x": 26,
		"y": 47
	},
	{
		"x": 27,
		"y": 47
	},
	{
		"x": 28,
		"y": 47
	},
	{
		"x": 29,
		"y": 47
	},
	{
		"x": 30,
		"y": 47
	},
	{
		"x": 31,
		"y": 47
	},
	{
		"x": 32,
		"y": 47
	},
	{
		"x": 33,
		"y": 47
	},
	{
		"x": 34,
		"y": 47
	},
	{
		"x": 35,
		"y": 47
	},
	{
		"x": 36,
		"y": 47
	},
	{
		"x": 37,
		"y": 47
	},
	{
		"x": 38,
		"y": 47
	},
	{
		"x": 39,
		"y": 47
	},
	{
		"x": 40,
		"y": 47
	},
	{
		"x": 41,
		"y": 47
	},
	{
		"x": 42,
		"y": 47
	},
	{
		"x": 43,
		"y": 47
	},
	{
		"x": 44,
		"y": 47
	},
	{
		"x": 45,
		"y": 47
	},
	{
		"x": 46,
		"y": 47
	},
	{
		"x": 47,
		"y": 47
	},
	{
		"x": 48,
		"y": 47
	},
	{
		"x": 49,
		"y": 47
	},
	{
		"x": 50,
		"y": 47
	},
	{
		"x": 51,
		"y": 47
	},
	{
		"x": 52,
		"y": 47
	},
	{
		"x": 53,
		"y": 47
	},
	{
		"x": 54,
		"y": 47
	},
	{
		"x": 55,
		"y": 47
	},
	{
		"x": 56,
		"y": 47
	},
	{
		"x": 57,
		"y": 47
	},
	{
		"x": 58,
		"y": 47
	},
	{
		"x": 59,
		"y": 47
	},
	{
		"x": 60,
		"y": 47
	},
	{
		"x": 61,
		"y": 47
	},
	{
		"x": 62,
		"y": 47
	},
	{
		"x": 63,
		"y": 47
	},
	{
		"x": 64,
		"y": 47
	},
	{
		"x": 65,
		"y": 47
	},
	{
		"x": 66,
		"y": 47
	},
	{
		"x": 67,
		"y": 47
	},
	{
		"x": 4,
		"y": 48
	},
	{
		"x": 5,
		"y": 48
	},
	{
		"x": 6,
		"y": 48
	},
	{
		"x": 7,
		"y": 48
	},
	{
		"x": 8,
		"y": 48
	},
	{
		"x": 9,
		"y": 48
	},
	{
		"x": 10,
		"y": 48
	},
	{
		"x": 11,
		"y": 48
	},
	{
		"x": 12,
		"y": 48
	},
	{
		"x": 13,
		"y": 48
	},
	{
		"x": 14,
		"y": 48
	},
	{
		"x": 15,
		"y": 48
	},
	{
		"x": 16,
		"y": 48
	},
	{
		"x": 17,
		"y": 48
	},
	{
		"x": 18,
		"y": 48
	},
	{
		"x": 19,
		"y": 48
	},
	{
		"x": 20,
		"y": 48
	},
	{
		"x": 21,
		"y": 48
	},
	{
		"x": 22,
		"y": 48
	},
	{
		"x": 23,
		"y": 48
	},
	{
		"x": 24,
		"y": 48
	},
	{
		"x": 25,
		"y": 48
	},
	{
		"x": 26,
		"y": 48
	},
	{
		"x": 27,
		"y": 48
	},
	{
		"x": 28,
		"y": 48
	},
	{
		"x": 29,
		"y": 48
	},
	{
		"x": 30,
		"y": 48
	},
	{
		"x": 31,
		"y": 48
	},
	{
		"x": 32,
		"y": 48
	},
	{
		"x": 33,
		"y": 48
	},
	{
		"x": 34,
		"y": 48
	},
	{
		"x": 35,
		"y": 48
	},
	{
		"x": 36,
		"y": 48
	},
	{
		"x": 37,
		"y": 48
	},
	{
		"x": 38,
		"y": 48
	},
	{
		"x": 39,
		"y": 48
	},
	{
		"x": 40,
		"y": 48
	},
	{
		"x": 41,
		"y": 48
	},
	{
		"x": 42,
		"y": 48
	},
	{
		"x": 43,
		"y": 48
	},
	{
		"x": 44,
		"y": 48
	},
	{
		"x": 45,
		"y": 48
	},
	{
		"x": 46,
		"y": 48
	},
	{
		"x": 47,
		"y": 48
	},
	{
		"x": 48,
		"y": 48
	},
	{
		"x": 49,
		"y": 48
	},
	{
		"x": 50,
		"y": 48
	},
	{
		"x": 51,
		"y": 48
	},
	{
		"x": 52,
		"y": 48
	},
	{
		"x": 53,
		"y": 48
	},
	{
		"x": 54,
		"y": 48
	},
	{
		"x": 55,
		"y": 48
	},
	{
		"x": 56,
		"y": 48
	},
	{
		"x": 57,
		"y": 48
	},
	{
		"x": 58,
		"y": 48
	},
	{
		"x": 59,
		"y": 48
	},
	{
		"x": 60,
		"y": 48
	},
	{
		"x": 61,
		"y": 48
	},
	{
		"x": 62,
		"y": 48
	},
	{
		"x": 63,
		"y": 48
	},
	{
		"x": 64,
		"y": 48
	},
	{
		"x": 65,
		"y": 48
	},
	{
		"x": 66,
		"y": 48
	},
	{
		"x": 6,
		"y": 49
	},
	{
		"x": 7,
		"y": 49
	},
	{
		"x": 8,
		"y": 49
	},
	{
		"x": 9,
		"y": 49
	},
	{
		"x": 10,
		"y": 49
	},
	{
		"x": 11,
		"y": 49
	},
	{
		"x": 12,
		"y": 49
	},
	{
		"x": 13,
		"y": 49
	},
	{
		"x": 14,
		"y": 49
	},
	{
		"x": 15,
		"y": 49
	},
	{
		"x": 16,
		"y": 49
	},
	{
		"x": 17,
		"y": 49
	},
	{
		"x": 18,
		"y": 49
	},
	{
		"x": 19,
		"y": 49
	},
	{
		"x": 20,
		"y": 49
	},
	{
		"x": 21,
		"y": 49
	},
	{
		"x": 22,
		"y": 49
	},
	{
		"x": 23,
		"y": 49
	},
	{
		"x": 24,
		"y": 49
	},
	{
		"x": 25,
		"y": 49
	},
	{
		"x": 26,
		"y": 49
	},
	{
		"x": 27,
		"y": 49
	},
	{
		"x": 28,
		"y": 49
	},
	{
		"x": 29,
		"y": 49
	},
	{
		"x": 30,
		"y": 49
	},
	{
		"x": 31,
		"y": 49
	},
	{
		"x": 32,
		"y": 49
	},
	{
		"x": 33,
		"y": 49
	},
	{
		"x": 34,
		"y": 49
	},
	{
		"x": 35,
		"y": 49
	},
	{
		"x": 36,
		"y": 49
	},
	{
		"x": 37,
		"y": 49
	},
	{
		"x": 38,
		"y": 49
	},
	{
		"x": 39,
		"y": 49
	},
	{
		"x": 40,
		"y": 49
	},
	{
		"x": 41,
		"y": 49
	},
	{
		"x": 42,
		"y": 49
	},
	{
		"x": 43,
		"y": 49
	},
	{
		"x": 44,
		"y": 49
	},
	{
		"x": 45,
		"y": 49
	},
	{
		"x": 46,
		"y": 49
	},
	{
		"x": 47,
		"y": 49
	},
	{
		"x": 48,
		"y": 49
	},
	{
		"x": 49,
		"y": 49
	},
	{
		"x": 50,
		"y": 49
	},
	{
		"x": 51,
		"y": 49
	},
	{
		"x": 52,
		"y": 49
	},
	{
		"x": 53,
		"y": 49
	},
	{
		"x": 54,
		"y": 49
	},
	{
		"x": 55,
		"y": 49
	},
	{
		"x": 56,
		"y": 49
	},
	{
		"x": 57,
		"y": 49
	},
	{
		"x": 58,
		"y": 49
	},
	{
		"x": 59,
		"y": 49
	},
	{
		"x": 60,
		"y": 49
	},
	{
		"x": 61,
		"y": 49
	},
	{
		"x": 62,
		"y": 49
	},
	{
		"x": 63,
		"y": 49
	},
	{
		"x": 64,
		"y": 49
	},
	{
		"x": 7,
		"y": 50
	},
	{
		"x": 8,
		"y": 50
	},
	{
		"x": 9,
		"y": 50
	},
	{
		"x": 10,
		"y": 50
	},
	{
		"x": 11,
		"y": 50
	},
	{
		"x": 12,
		"y": 50
	},
	{
		"x": 13,
		"y": 50
	},
	{
		"x": 14,
		"y": 50
	},
	{
		"x": 15,
		"y": 50
	},
	{
		"x": 16,
		"y": 50
	},
	{
		"x": 17,
		"y": 50
	},
	{
		"x": 18,
		"y": 50
	},
	{
		"x": 19,
		"y": 50
	},
	{
		"x": 20,
		"y": 50
	},
	{
		"x": 21,
		"y": 50
	},
	{
		"x": 22,
		"y": 50
	},
	{
		"x": 23,
		"y": 50
	},
	{
		"x": 24,
		"y": 50
	},
	{
		"x": 25,
		"y": 50
	},
	{
		"x": 26,
		"y": 50
	},
	{
		"x": 27,
		"y": 50
	},
	{
		"x": 28,
		"y": 50
	},
	{
		"x": 29,
		"y": 50
	},
	{
		"x": 30,
		"y": 50
	},
	{
		"x": 31,
		"y": 50
	},
	{
		"x": 32,
		"y": 50
	},
	{
		"x": 33,
		"y": 50
	},
	{
		"x": 34,
		"y": 50
	},
	{
		"x": 35,
		"y": 50
	},
	{
		"x": 36,
		"y": 50
	},
	{
		"x": 37,
		"y": 50
	},
	{
		"x": 38,
		"y": 50
	},
	{
		"x": 39,
		"y": 50
	},
	{
		"x": 40,
		"y": 50
	},
	{
		"x": 41,
		"y": 50
	},
	{
		"x": 42,
		"y": 50
	},
	{
		"x": 43,
		"y": 50
	},
	{
		"x": 44,
		"y": 50
	},
	{
		"x": 45,
		"y": 50
	},
	{
		"x": 46,
		"y": 50
	},
	{
		"x": 47,
		"y": 50
	},
	{
		"x": 48,
		"y": 50
	},
	{
		"x": 49,
		"y": 50
	},
	{
		"x": 50,
		"y": 50
	},
	{
		"x": 51,
		"y": 50
	},
	{
		"x": 52,
		"y": 50
	},
	{
		"x": 53,
		"y": 50
	},
	{
		"x": 54,
		"y": 50
	},
	{
		"x": 55,
		"y": 50
	},
	{
		"x": 56,
		"y": 50
	},
	{
		"x": 57,
		"y": 50
	},
	{
		"x": 58,
		"y": 50
	},
	{
		"x": 59,
		"y": 50
	},
	{
		"x": 60,
		"y": 50
	},
	{
		"x": 61,
		"y": 50
	},
	{
		"x": 62,
		"y": 50
	},
	{
		"x": 63,
		"y": 50
	},
	{
		"x": 8,
		"y": 51
	},
	{
		"x": 9,
		"y": 51
	},
	{
		"x": 10,
		"y": 51
	},
	{
		"x": 11,
		"y": 51
	},
	{
		"x": 12,
		"y": 51
	},
	{
		"x": 13,
		"y": 51
	},
	{
		"x": 14,
		"y": 51
	},
	{
		"x": 15,
		"y": 51
	},
	{
		"x": 16,
		"y": 51
	},
	{
		"x": 17,
		"y": 51
	},
	{
		"x": 18,
		"y": 51
	},
	{
		"x": 19,
		"y": 51
	},
	{
		"x": 20,
		"y": 51
	},
	{
		"x": 22,
		"y": 51
	},
	{
		"x": 23,
		"y": 51
	},
	{
		"x": 24,
		"y": 51
	},
	{
		"x": 26,
		"y": 51
	},
	{
		"x": 27,
		"y": 51
	},
	{
		"x": 28,
		"y": 51
	},
	{
		"x": 29,
		"y": 51
	},
	{
		"x": 31,
		"y": 51
	},
	{
		"x": 32,
		"y": 51
	},
	{
		"x": 33,
		"y": 51
	},
	{
		"x": 34,
		"y": 51
	},
	{
		"x": 35,
		"y": 51
	},
	{
		"x": 36,
		"y": 51
	},
	{
		"x": 37,
		"y": 51
	},
	{
		"x": 38,
		"y": 51
	},
	{
		"x": 39,
		"y": 51
	},
	{
		"x": 40,
		"y": 51
	},
	{
		"x": 41,
		"y": 51
	},
	{
		"x": 42,
		"y": 51
	},
	{
		"x": 43,
		"y": 51
	},
	{
		"x": 45,
		"y": 51
	},
	{
		"x": 46,
		"y": 51
	},
	{
		"x": 48,
		"y": 51
	},
	{
		"x": 49,
		"y": 51
	},
	{
		"x": 50,
		"y": 51
	},
	{
		"x": 52,
		"y": 51
	},
	{
		"x": 53,
		"y": 51
	},
	{
		"x": 54,
		"y": 51
	},
	{
		"x": 55,
		"y": 51
	},
	{
		"x": 56,
		"y": 51
	},
	{
		"x": 57,
		"y": 51
	},
	{
		"x": 58,
		"y": 51
	},
	{
		"x": 59,
		"y": 51
	},
	{
		"x": 60,
		"y": 51
	},
	{
		"x": 61,
		"y": 51
	},
	{
		"x": 62,
		"y": 51
	},
	{
		"x": 10,
		"y": 52
	},
	{
		"x": 11,
		"y": 52
	},
	{
		"x": 12,
		"y": 52
	},
	{
		"x": 13,
		"y": 52
	},
	{
		"x": 14,
		"y": 52
	},
	{
		"x": 15,
		"y": 52
	},
	{
		"x": 16,
		"y": 52
	},
	{
		"x": 17,
		"y": 52
	},
	{
		"x": 18,
		"y": 52
	},
	{
		"x": 19,
		"y": 52
	},
	{
		"x": 20,
		"y": 52
	},
	{
		"x": 22,
		"y": 52
	},
	{
		"x": 23,
		"y": 52
	},
	{
		"x": 24,
		"y": 52
	},
	{
		"x": 25,
		"y": 52
	},
	{
		"x": 26,
		"y": 52
	},
	{
		"x": 27,
		"y": 52
	},
	{
		"x": 28,
		"y": 52
	},
	{
		"x": 29,
		"y": 52
	},
	{
		"x": 30,
		"y": 52
	},
	{
		"x": 32,
		"y": 52
	},
	{
		"x": 33,
		"y": 52
	},
	{
		"x": 34,
		"y": 52
	},
	{
		"x": 35,
		"y": 52
	},
	{
		"x": 36,
		"y": 52
	},
	{
		"x": 38,
		"y": 52
	},
	{
		"x": 39,
		"y": 52
	},
	{
		"x": 40,
		"y": 52
	},
	{
		"x": 42,
		"y": 52
	},
	{
		"x": 43,
		"y": 52
	},
	{
		"x": 44,
		"y": 52
	},
	{
		"x": 45,
		"y": 52
	},
	{
		"x": 46,
		"y": 52
	},
	{
		"x": 47,
		"y": 52
	},
	{
		"x": 48,
		"y": 52
	},
	{
		"x": 49,
		"y": 52
	},
	{
		"x": 50,
		"y": 52
	},
	{
		"x": 51,
		"y": 52
	},
	{
		"x": 52,
		"y": 52
	},
	{
		"x": 53,
		"y": 52
	},
	{
		"x": 54,
		"y": 52
	},
	{
		"x": 55,
		"y": 52
	},
	{
		"x": 56,
		"y": 52
	},
	{
		"x": 57,
		"y": 52
	},
	{
		"x": 58,
		"y": 52
	},
	{
		"x": 59,
		"y": 52
	},
	{
		"x": 60,
		"y": 52
	},
	{
		"x": 11,
		"y": 53
	},
	{
		"x": 12,
		"y": 53
	},
	{
		"x": 13,
		"y": 53
	},
	{
		"x": 14,
		"y": 53
	},
	{
		"x": 15,
		"y": 53
	},
	{
		"x": 16,
		"y": 53
	},
	{
		"x": 17,
		"y": 53
	},
	{
		"x": 18,
		"y": 53
	},
	{
		"x": 19,
		"y": 53
	},
	{
		"x": 20,
		"y": 53
	},
	{
		"x": 21,
		"y": 53
	},
	{
		"x": 22,
		"y": 53
	},
	{
		"x": 23,
		"y": 53
	},
	{
		"x": 24,
		"y": 53
	},
	{
		"x": 25,
		"y": 53
	},
	{
		"x": 26,
		"y": 53
	},
	{
		"x": 27,
		"y": 53
	},
	{
		"x": 28,
		"y": 53
	},
	{
		"x": 29,
		"y": 53
	},
	{
		"x": 30,
		"y": 53
	},
	{
		"x": 31,
		"y": 53
	},
	{
		"x": 32,
		"y": 53
	},
	{
		"x": 33,
		"y": 53
	},
	{
		"x": 34,
		"y": 53
	},
	{
		"x": 35,
		"y": 53
	},
	{
		"x": 36,
		"y": 53
	},
	{
		"x": 37,
		"y": 53
	},
	{
		"x": 38,
		"y": 53
	},
	{
		"x": 39,
		"y": 53
	},
	{
		"x": 40,
		"y": 53
	},
	{
		"x": 41,
		"y": 53
	},
	{
		"x": 42,
		"y": 53
	},
	{
		"x": 43,
		"y": 53
	},
	{
		"x": 44,
		"y": 53
	},
	{
		"x": 45,
		"y": 53
	},
	{
		"x": 46,
		"y": 53
	},
	{
		"x": 47,
		"y": 53
	},
	{
		"x": 48,
		"y": 53
	},
	{
		"x": 49,
		"y": 53
	},
	{
		"x": 50,
		"y": 53
	},
	{
		"x": 51,
		"y": 53
	},
	{
		"x": 52,
		"y": 53
	},
	{
		"x": 53,
		"y": 53
	},
	{
		"x": 54,
		"y": 53
	},
	{
		"x": 55,
		"y": 53
	},
	{
		"x": 56,
		"y": 53
	},
	{
		"x": 57,
		"y": 53
	},
	{
		"x": 58,
		"y": 53
	},
	{
		"x": 59,
		"y": 53
	},
	{
		"x": 12,
		"y": 54
	},
	{
		"x": 13,
		"y": 54
	},
	{
		"x": 14,
		"y": 54
	},
	{
		"x": 15,
		"y": 54
	},
	{
		"x": 16,
		"y": 54
	},
	{
		"x": 17,
		"y": 54
	},
	{
		"x": 18,
		"y": 54
	},
	{
		"x": 19,
		"y": 54
	},
	{
		"x": 20,
		"y": 54
	},
	{
		"x": 21,
		"y": 54
	},
	{
		"x": 22,
		"y": 54
	},
	{
		"x": 23,
		"y": 54
	},
	{
		"x": 24,
		"y": 54
	},
	{
		"x": 25,
		"y": 54
	},
	{
		"x": 26,
		"y": 54
	},
	{
		"x": 27,
		"y": 54
	},
	{
		"x": 28,
		"y": 54
	},
	{
		"x": 29,
		"y": 54
	},
	{
		"x": 30,
		"y": 54
	},
	{
		"x": 31,
		"y": 54
	},
	{
		"x": 32,
		"y": 54
	},
	{
		"x": 33,
		"y": 54
	},
	{
		"x": 34,
		"y": 54
	},
	{
		"x": 35,
		"y": 54
	},
	{
		"x": 36,
		"y": 54
	},
	{
		"x": 37,
		"y": 54
	},
	{
		"x": 38,
		"y": 54
	},
	{
		"x": 39,
		"y": 54
	},
	{
		"x": 40,
		"y": 54
	},
	{
		"x": 41,
		"y": 54
	},
	{
		"x": 42,
		"y": 54
	},
	{
		"x": 43,
		"y": 54
	},
	{
		"x": 44,
		"y": 54
	},
	{
		"x": 45,
		"y": 54
	},
	{
		"x": 46,
		"y": 54
	},
	{
		"x": 47,
		"y": 54
	},
	{
		"x": 48,
		"y": 54
	},
	{
		"x": 49,
		"y": 54
	},
	{
		"x": 50,
		"y": 54
	},
	{
		"x": 51,
		"y": 54
	},
	{
		"x": 52,
		"y": 54
	},
	{
		"x": 53,
		"y": 54
	},
	{
		"x": 54,
		"y": 54
	},
	{
		"x": 55,
		"y": 54
	},
	{
		"x": 56,
		"y": 54
	},
	{
		"x": 57,
		"y": 54
	},
	{
		"x": 58,
		"y": 54
	},
	{
		"x": 14,
		"y": 55
	},
	{
		"x": 15,
		"y": 55
	},
	{
		"x": 16,
		"y": 55
	},
	{
		"x": 17,
		"y": 55
	},
	{
		"x": 18,
		"y": 55
	},
	{
		"x": 19,
		"y": 55
	},
	{
		"x": 20,
		"y": 55
	},
	{
		"x": 21,
		"y": 55
	},
	{
		"x": 22,
		"y": 55
	},
	{
		"x": 23,
		"y": 55
	},
	{
		"x": 24,
		"y": 55
	},
	{
		"x": 25,
		"y": 55
	},
	{
		"x": 26,
		"y": 55
	},
	{
		"x": 27,
		"y": 55
	},
	{
		"x": 28,
		"y": 55
	},
	{
		"x": 29,
		"y": 55
	},
	{
		"x": 30,
		"y": 55
	},
	{
		"x": 31,
		"y": 55
	},
	{
		"x": 32,
		"y": 55
	},
	{
		"x": 33,
		"y": 55
	},
	{
		"x": 34,
		"y": 55
	},
	{
		"x": 35,
		"y": 55
	},
	{
		"x": 36,
		"y": 55
	},
	{
		"x": 37,
		"y": 55
	},
	{
		"x": 38,
		"y": 55
	},
	{
		"x": 39,
		"y": 55
	},
	{
		"x": 40,
		"y": 55
	},
	{
		"x": 41,
		"y": 55
	},
	{
		"x": 42,
		"y": 55
	},
	{
		"x": 43,
		"y": 55
	},
	{
		"x": 44,
		"y": 55
	},
	{
		"x": 45,
		"y": 55
	},
	{
		"x": 46,
		"y": 55
	},
	{
		"x": 47,
		"y": 55
	},
	{
		"x": 48,
		"y": 55
	},
	{
		"x": 49,
		"y": 55
	},
	{
		"x": 50,
		"y": 55
	},
	{
		"x": 51,
		"y": 55
	},
	{
		"x": 52,
		"y": 55
	},
	{
		"x": 53,
		"y": 55
	},
	{
		"x": 54,
		"y": 55
	},
	{
		"x": 55,
		"y": 55
	},
	{
		"x": 56,
		"y": 55
	},
	{
		"x": 15,
		"y": 56
	},
	{
		"x": 16,
		"y": 56
	},
	{
		"x": 17,
		"y": 56
	},
	{
		"x": 18,
		"y": 56
	},
	{
		"x": 19,
		"y": 56
	},
	{
		"x": 20,
		"y": 56
	},
	{
		"x": 21,
		"y": 56
	},
	{
		"x": 22,
		"y": 56
	},
	{
		"x": 23,
		"y": 56
	},
	{
		"x": 24,
		"y": 56
	},
	{
		"x": 25,
		"y": 56
	},
	{
		"x": 26,
		"y": 56
	},
	{
		"x": 27,
		"y": 56
	},
	{
		"x": 28,
		"y": 56
	},
	{
		"x": 29,
		"y": 56
	},
	{
		"x": 30,
		"y": 56
	},
	{
		"x": 31,
		"y": 56
	},
	{
		"x": 32,
		"y": 56
	},
	{
		"x": 33,
		"y": 56
	},
	{
		"x": 34,
		"y": 56
	},
	{
		"x": 35,
		"y": 56
	},
	{
		"x": 36,
		"y": 56
	},
	{
		"x": 37,
		"y": 56
	},
	{
		"x": 38,
		"y": 56
	},
	{
		"x": 39,
		"y": 56
	},
	{
		"x": 40,
		"y": 56
	},
	{
		"x": 41,
		"y": 56
	},
	{
		"x": 42,
		"y": 56
	},
	{
		"x": 43,
		"y": 56
	},
	{
		"x": 44,
		"y": 56
	},
	{
		"x": 45,
		"y": 56
	},
	{
		"x": 46,
		"y": 56
	},
	{
		"x": 47,
		"y": 56
	},
	{
		"x": 48,
		"y": 56
	},
	{
		"x": 49,
		"y": 56
	},
	{
		"x": 50,
		"y": 56
	},
	{
		"x": 51,
		"y": 56
	},
	{
		"x": 52,
		"y": 56
	},
	{
		"x": 53,
		"y": 56
	},
	{
		"x": 54,
		"y": 56
	},
	{
		"x": 55,
		"y": 56
	},
	{
		"x": 16,
		"y": 57
	},
	{
		"x": 17,
		"y": 57
	},
	{
		"x": 18,
		"y": 57
	},
	{
		"x": 19,
		"y": 57
	},
	{
		"x": 20,
		"y": 57
	},
	{
		"x": 21,
		"y": 57
	},
	{
		"x": 22,
		"y": 57
	},
	{
		"x": 23,
		"y": 57
	},
	{
		"x": 24,
		"y": 57
	},
	{
		"x": 25,
		"y": 57
	},
	{
		"x": 26,
		"y": 57
	},
	{
		"x": 27,
		"y": 57
	},
	{
		"x": 28,
		"y": 57
	},
	{
		"x": 29,
		"y": 57
	},
	{
		"x": 30,
		"y": 57
	},
	{
		"x": 31,
		"y": 57
	},
	{
		"x": 32,
		"y": 57
	},
	{
		"x": 33,
		"y": 57
	},
	{
		"x": 34,
		"y": 57
	},
	{
		"x": 35,
		"y": 57
	},
	{
		"x": 36,
		"y": 57
	},
	{
		"x": 37,
		"y": 57
	},
	{
		"x": 38,
		"y": 57
	},
	{
		"x": 39,
		"y": 57
	},
	{
		"x": 40,
		"y": 57
	},
	{
		"x": 41,
		"y": 57
	},
	{
		"x": 42,
		"y": 57
	},
	{
		"x": 43,
		"y": 57
	},
	{
		"x": 44,
		"y": 57
	},
	{
		"x": 45,
		"y": 57
	},
	{
		"x": 46,
		"y": 57
	},
	{
		"x": 47,
		"y": 57
	},
	{
		"x": 48,
		"y": 57
	},
	{
		"x": 49,
		"y": 57
	},
	{
		"x": 50,
		"y": 57
	},
	{
		"x": 51,
		"y": 57
	},
	{
		"x": 52,
		"y": 57
	},
	{
		"x": 53,
		"y": 57
	},
	{
		"x": 54,
		"y": 57
	},
	{
		"x": 18,
		"y": 58
	},
	{
		"x": 19,
		"y": 58
	},
	{
		"x": 20,
		"y": 58
	},
	{
		"x": 21,
		"y": 58
	},
	{
		"x": 22,
		"y": 58
	},
	{
		"x": 23,
		"y": 58
	},
	{
		"x": 24,
		"y": 58
	},
	{
		"x": 25,
		"y": 58
	},
	{
		"x": 26,
		"y": 58
	},
	{
		"x": 27,
		"y": 58
	},
	{
		"x": 28,
		"y": 58
	},
	{
		"x": 29,
		"y": 58
	},
	{
		"x": 30,
		"y": 58
	},
	{
		"x": 31,
		"y": 58
	},
	{
		"x": 32,
		"y": 58
	},
	{
		"x": 33,
		"y": 58
	},
	{
		"x": 34,
		"y": 58
	},
	{
		"x": 35,
		"y": 58
	},
	{
		"x": 36,
		"y": 58
	},
	{
		"x": 37,
		"y": 58
	},
	{
		"x": 38,
		"y": 58
	},
	{
		"x": 39,
		"y": 58
	},
	{
		"x": 40,
		"y": 58
	},
	{
		"x": 41,
		"y": 58
	},
	{
		"x": 42,
		"y": 58
	},
	{
		"x": 43,
		"y": 58
	},
	{
		"x": 44,
		"y": 58
	},
	{
		"x": 45,
		"y": 58
	},
	{
		"x": 46,
		"y": 58
	},
	{
		"x": 47,
		"y": 58
	},
	{
		"x": 48,
		"y": 58
	},
	{
		"x": 49,
		"y": 58
	},
	{
		"x": 50,
		"y": 58
	},
	{
		"x": 51,
		"y": 58
	},
	{
		"x": 52,
		"y": 58
	},
	{
		"x": 19,
		"y": 59
	},
	{
		"x": 20,
		"y": 59
	},
	{
		"x": 21,
		"y": 59
	},
	{
		"x": 22,
		"y": 59
	},
	{
		"x": 23,
		"y": 59
	},
	{
		"x": 24,
		"y": 59
	},
	{
		"x": 25,
		"y": 59
	},
	{
		"x": 26,
		"y": 59
	},
	{
		"x": 27,
		"y": 59
	},
	{
		"x": 28,
		"y": 59
	},
	{
		"x": 29,
		"y": 59
	},
	{
		"x": 30,
		"y": 59
	},
	{
		"x": 31,
		"y": 59
	},
	{
		"x": 32,
		"y": 59
	},
	{
		"x": 33,
		"y": 59
	},
	{
		"x": 34,
		"y": 59
	},
	{
		"x": 35,
		"y": 59
	},
	{
		"x": 36,
		"y": 59
	},
	{
		"x": 37,
		"y": 59
	},
	{
		"x": 38,
		"y": 59
	},
	{
		"x": 39,
		"y": 59
	},
	{
		"x": 40,
		"y": 59
	},
	{
		"x": 41,
		"y": 59
	},
	{
		"x": 42,
		"y": 59
	},
	{
		"x": 43,
		"y": 59
	},
	{
		"x": 44,
		"y": 59
	},
	{
		"x": 45,
		"y": 59
	},
	{
		"x": 46,
		"y": 59
	},
	{
		"x": 47,
		"y": 59
	},
	{
		"x": 48,
		"y": 59
	},
	{
		"x": 49,
		"y": 59
	},
	{
		"x": 50,
		"y": 59
	},
	{
		"x": 51,
		"y": 59
	},
	{
		"x": 21,
		"y": 60
	},
	{
		"x": 22,
		"y": 60
	},
	{
		"x": 23,
		"y": 60
	},
	{
		"x": 24,
		"y": 60
	},
	{
		"x": 25,
		"y": 60
	},
	{
		"x": 26,
		"y": 60
	},
	{
		"x": 27,
		"y": 60
	},
	{
		"x": 28,
		"y": 60
	},
	{
		"x": 29,
		"y": 60
	},
	{
		"x": 30,
		"y": 60
	},
	{
		"x": 31,
		"y": 60
	},
	{
		"x": 32,
		"y": 60
	},
	{
		"x": 33,
		"y": 60
	},
	{
		"x": 34,
		"y": 60
	},
	{
		"x": 35,
		"y": 60
	},
	{
		"x": 36,
		"y": 60
	},
	{
		"x": 37,
		"y": 60
	},
	{
		"x": 38,
		"y": 60
	},
	{
		"x": 39,
		"y": 60
	},
	{
		"x": 40,
		"y": 60
	},
	{
		"x": 41,
		"y": 60
	},
	{
		"x": 42,
		"y": 60
	},
	{
		"x": 43,
		"y": 60
	},
	{
		"x": 44,
		"y": 60
	},
	{
		"x": 45,
		"y": 60
	},
	{
		"x": 46,
		"y": 60
	},
	{
		"x": 47,
		"y": 60
	},
	{
		"x": 48,
		"y": 60
	},
	{
		"x": 49,
		"y": 60
	},
	{
		"x": 21,
		"y": 61
	},
	{
		"x": 22,
		"y": 61
	},
	{
		"x": 23,
		"y": 61
	},
	{
		"x": 24,
		"y": 61
	},
	{
		"x": 25,
		"y": 61
	},
	{
		"x": 26,
		"y": 61
	},
	{
		"x": 27,
		"y": 61
	},
	{
		"x": 28,
		"y": 61
	},
	{
		"x": 29,
		"y": 61
	},
	{
		"x": 30,
		"y": 61
	},
	{
		"x": 31,
		"y": 61
	},
	{
		"x": 32,
		"y": 61
	},
	{
		"x": 33,
		"y": 61
	},
	{
		"x": 34,
		"y": 61
	},
	{
		"x": 35,
		"y": 61
	},
	{
		"x": 36,
		"y": 61
	},
	{
		"x": 37,
		"y": 61
	},
	{
		"x": 38,
		"y": 61
	},
	{
		"x": 39,
		"y": 61
	},
	{
		"x": 40,
		"y": 61
	},
	{
		"x": 41,
		"y": 61
	},
	{
		"x": 42,
		"y": 61
	},
	{
		"x": 43,
		"y": 61
	},
	{
		"x": 44,
		"y": 61
	},
	{
		"x": 45,
		"y": 61
	},
	{
		"x": 46,
		"y": 61
	},
	{
		"x": 47,
		"y": 61
	},
	{
		"x": 48,
		"y": 61
	},
	{
		"x": 49,
		"y": 61
	},
	{
		"x": 21,
		"y": 62
	},
	{
		"x": 22,
		"y": 62
	},
	{
		"x": 23,
		"y": 62
	},
	{
		"x": 24,
		"y": 62
	},
	{
		"x": 25,
		"y": 62
	},
	{
		"x": 26,
		"y": 62
	},
	{
		"x": 27,
		"y": 62
	},
	{
		"x": 28,
		"y": 62
	},
	{
		"x": 29,
		"y": 62
	},
	{
		"x": 30,
		"y": 62
	},
	{
		"x": 31,
		"y": 62
	},
	{
		"x": 32,
		"y": 62
	},
	{
		"x": 33,
		"y": 62
	},
	{
		"x": 34,
		"y": 62
	},
	{
		"x": 35,
		"y": 62
	},
	{
		"x": 36,
		"y": 62
	},
	{
		"x": 37,
		"y": 62
	},
	{
		"x": 38,
		"y": 62
	},
	{
		"x": 39,
		"y": 62
	},
	{
		"x": 40,
		"y": 62
	},
	{
		"x": 41,
		"y": 62
	},
	{
		"x": 42,
		"y": 62
	},
	{
		"x": 43,
		"y": 62
	},
	{
		"x": 44,
		"y": 62
	},
	{
		"x": 45,
		"y": 62
	},
	{
		"x": 46,
		"y": 62
	},
	{
		"x": 47,
		"y": 62
	},
	{
		"x": 48,
		"y": 62
	},
	{
		"x": 49,
		"y": 62
	},
	{
		"x": 20,
		"y": 63
	},
	{
		"x": 21,
		"y": 63
	},
	{
		"x": 22,
		"y": 63
	},
	{
		"x": 23,
		"y": 63
	},
	{
		"x": 24,
		"y": 63
	},
	{
		"x": 25,
		"y": 63
	},
	{
		"x": 26,
		"y": 63
	},
	{
		"x": 27,
		"y": 63
	},
	{
		"x": 28,
		"y": 63
	},
	{
		"x": 29,
		"y": 63
	},
	{
		"x": 30,
		"y": 63
	},
	{
		"x": 31,
		"y": 63
	},
	{
		"x": 32,
		"y": 63
	},
	{
		"x": 33,
		"y": 63
	},
	{
		"x": 34,
		"y": 63
	},
	{
		"x": 35,
		"y": 63
	},
	{
		"x": 36,
		"y": 63
	},
	{
		"x": 37,
		"y": 63
	},
	{
		"x": 38,
		"y": 63
	},
	{
		"x": 39,
		"y": 63
	},
	{
		"x": 40,
		"y": 63
	},
	{
		"x": 41,
		"y": 63
	},
	{
		"x": 42,
		"y": 63
	},
	{
		"x": 43,
		"y": 63
	},
	{
		"x": 44,
		"y": 63
	},
	{
		"x": 45,
		"y": 63
	},
	{
		"x": 46,
		"y": 63
	},
	{
		"x": 47,
		"y": 63
	},
	{
		"x": 48,
		"y": 63
	},
	{
		"x": 49,
		"y": 63
	},
	{
		"x": 50,
		"y": 63
	},
	{
		"x": 20,
		"y": 64
	},
	{
		"x": 21,
		"y": 64
	},
	{
		"x": 22,
		"y": 64
	},
	{
		"x": 23,
		"y": 64
	},
	{
		"x": 24,
		"y": 64
	},
	{
		"x": 25,
		"y": 64
	},
	{
		"x": 26,
		"y": 64
	},
	{
		"x": 27,
		"y": 64
	},
	{
		"x": 28,
		"y": 64
	},
	{
		"x": 29,
		"y": 64
	},
	{
		"x": 30,
		"y": 64
	},
	{
		"x": 31,
		"y": 64
	},
	{
		"x": 32,
		"y": 64
	},
	{
		"x": 33,
		"y": 64
	},
	{
		"x": 34,
		"y": 64
	},
	{
		"x": 35,
		"y": 64
	},
	{
		"x": 36,
		"y": 64
	},
	{
		"x": 37,
		"y": 64
	},
	{
		"x": 38,
		"y": 64
	},
	{
		"x": 39,
		"y": 64
	},
	{
		"x": 40,
		"y": 64
	},
	{
		"x": 41,
		"y": 64
	},
	{
		"x": 42,
		"y": 64
	},
	{
		"x": 43,
		"y": 64
	},
	{
		"x": 44,
		"y": 64
	},
	{
		"x": 45,
		"y": 64
	},
	{
		"x": 46,
		"y": 64
	},
	{
		"x": 47,
		"y": 64
	},
	{
		"x": 48,
		"y": 64
	},
	{
		"x": 49,
		"y": 64
	},
	{
		"x": 50,
		"y": 64
	},
	{
		"x": 20,
		"y": 65
	},
	{
		"x": 21,
		"y": 65
	},
	{
		"x": 22,
		"y": 65
	},
	{
		"x": 23,
		"y": 65
	},
	{
		"x": 24,
		"y": 65
	},
	{
		"x": 25,
		"y": 65
	},
	{
		"x": 26,
		"y": 65
	},
	{
		"x": 27,
		"y": 65
	},
	{
		"x": 28,
		"y": 65
	},
	{
		"x": 29,
		"y": 65
	},
	{
		"x": 30,
		"y": 65
	},
	{
		"x": 31,
		"y": 65
	},
	{
		"x": 32,
		"y": 65
	},
	{
		"x": 33,
		"y": 65
	},
	{
		"x": 34,
		"y": 65
	},
	{
		"x": 35,
		"y": 65
	},
	{
		"x": 36,
		"y": 65
	},
	{
		"x": 37,
		"y": 65
	},
	{
		"x": 38,
		"y": 65
	},
	{
		"x": 39,
		"y": 65
	},
	{
		"x": 40,
		"y": 65
	},
	{
		"x": 41,
		"y": 65
	},
	{
		"x": 42,
		"y": 65
	},
	{
		"x": 43,
		"y": 65
	},
	{
		"x": 44,
		"y": 65
	},
	{
		"x": 45,
		"y": 65
	},
	{
		"x": 46,
		"y": 65
	},
	{
		"x": 47,
		"y": 65
	},
	{
		"x": 48,
		"y": 65
	},
	{
		"x": 49,
		"y": 65
	},
	{
		"x": 50,
		"y": 65
	},
	{
		"x": 20,
		"y": 66
	},
	{
		"x": 21,
		"y": 66
	},
	{
		"x": 22,
		"y": 66
	},
	{
		"x": 23,
		"y": 66
	},
	{
		"x": 24,
		"y": 66
	},
	{
		"x": 25,
		"y": 66
	},
	{
		"x": 26,
		"y": 66
	},
	{
		"x": 27,
		"y": 66
	},
	{
		"x": 28,
		"y": 66
	},
	{
		"x": 29,
		"y": 66
	},
	{
		"x": 30,
		"y": 66
	},
	{
		"x": 31,
		"y": 66
	},
	{
		"x": 32,
		"y": 66
	},
	{
		"x": 33,
		"y": 66
	},
	{
		"x": 34,
		"y": 66
	},
	{
		"x": 35,
		"y": 66
	},
	{
		"x": 36,
		"y": 66
	},
	{
		"x": 37,
		"y": 66
	},
	{
		"x": 38,
		"y": 66
	},
	{
		"x": 39,
		"y": 66
	},
	{
		"x": 40,
		"y": 66
	},
	{
		"x": 41,
		"y": 66
	},
	{
		"x": 42,
		"y": 66
	},
	{
		"x": 43,
		"y": 66
	},
	{
		"x": 44,
		"y": 66
	},
	{
		"x": 45,
		"y": 66
	},
	{
		"x": 46,
		"y": 66
	},
	{
		"x": 47,
		"y": 66
	},
	{
		"x": 48,
		"y": 66
	},
	{
		"x": 49,
		"y": 66
	},
	{
		"x": 50,
		"y": 66
	},
	{
		"x": 19,
		"y": 67
	},
	{
		"x": 20,
		"y": 67
	},
	{
		"x": 21,
		"y": 67
	},
	{
		"x": 22,
		"y": 67
	},
	{
		"x": 23,
		"y": 67
	},
	{
		"x": 24,
		"y": 67
	},
	{
		"x": 25,
		"y": 67
	},
	{
		"x": 26,
		"y": 67
	},
	{
		"x": 27,
		"y": 67
	},
	{
		"x": 28,
		"y": 67
	},
	{
		"x": 29,
		"y": 67
	},
	{
		"x": 30,
		"y": 67
	},
	{
		"x": 31,
		"y": 67
	},
	{
		"x": 32,
		"y": 67
	},
	{
		"x": 33,
		"y": 67
	},
	{
		"x": 34,
		"y": 67
	},
	{
		"x": 35,
		"y": 67
	},
	{
		"x": 36,
		"y": 67
	},
	{
		"x": 37,
		"y": 67
	},
	{
		"x": 38,
		"y": 67
	},
	{
		"x": 39,
		"y": 67
	},
	{
		"x": 40,
		"y": 67
	},
	{
		"x": 41,
		"y": 67
	},
	{
		"x": 42,
		"y": 67
	},
	{
		"x": 43,
		"y": 67
	},
	{
		"x": 44,
		"y": 67
	},
	{
		"x": 45,
		"y": 67
	},
	{
		"x": 46,
		"y": 67
	},
	{
		"x": 47,
		"y": 67
	},
	{
		"x": 48,
		"y": 67
	},
	{
		"x": 49,
		"y": 67
	},
	{
		"x": 50,
		"y": 67
	},
	{
		"x": 51,
		"y": 67
	},
	{
		"x": 19,
		"y": 68
	},
	{
		"x": 20,
		"y": 68
	},
	{
		"x": 21,
		"y": 68
	},
	{
		"x": 22,
		"y": 68
	},
	{
		"x": 23,
		"y": 68
	},
	{
		"x": 24,
		"y": 68
	},
	{
		"x": 25,
		"y": 68
	},
	{
		"x": 26,
		"y": 68
	},
	{
		"x": 27,
		"y": 68
	},
	{
		"x": 28,
		"y": 68
	},
	{
		"x": 29,
		"y": 68
	},
	{
		"x": 30,
		"y": 68
	},
	{
		"x": 31,
		"y": 68
	},
	{
		"x": 32,
		"y": 68
	},
	{
		"x": 33,
		"y": 68
	},
	{
		"x": 34,
		"y": 68
	},
	{
		"x": 35,
		"y": 68
	},
	{
		"x": 36,
		"y": 68
	},
	{
		"x": 37,
		"y": 68
	},
	{
		"x": 38,
		"y": 68
	},
	{
		"x": 39,
		"y": 68
	},
	{
		"x": 40,
		"y": 68
	},
	{
		"x": 41,
		"y": 68
	},
	{
		"x": 42,
		"y": 68
	},
	{
		"x": 43,
		"y": 68
	},
	{
		"x": 44,
		"y": 68
	},
	{
		"x": 45,
		"y": 68
	},
	{
		"x": 46,
		"y": 68
	},
	{
		"x": 47,
		"y": 68
	},
	{
		"x": 48,
		"y": 68
	},
	{
		"x": 49,
		"y": 68
	},
	{
		"x": 50,
		"y": 68
	},
	{
		"x": 51,
		"y": 68
	},
	{
		"x": 19,
		"y": 69
	},
	{
		"x": 20,
		"y": 69
	},
	{
		"x": 21,
		"y": 69
	},
	{
		"x": 22,
		"y": 69
	},
	{
		"x": 23,
		"y": 69
	},
	{
		"x": 24,
		"y": 69
	},
	{
		"x": 25,
		"y": 69
	},
	{
		"x": 26,
		"y": 69
	},
	{
		"x": 27,
		"y": 69
	},
	{
		"x": 28,
		"y": 69
	},
	{
		"x": 29,
		"y": 69
	},
	{
		"x": 30,
		"y": 69
	},
	{
		"x": 31,
		"y": 69
	},
	{
		"x": 32,
		"y": 69
	},
	{
		"x": 33,
		"y": 69
	},
	{
		"x": 34,
		"y": 69
	},
	{
		"x": 35,
		"y": 69
	},
	{
		"x": 36,
		"y": 69
	},
	{
		"x": 37,
		"y": 69
	},
	{
		"x": 38,
		"y": 69
	},
	{
		"x": 39,
		"y": 69
	},
	{
		"x": 40,
		"y": 69
	},
	{
		"x": 41,
		"y": 69
	},
	{
		"x": 42,
		"y": 69
	},
	{
		"x": 43,
		"y": 69
	},
	{
		"x": 44,
		"y": 69
	},
	{
		"x": 45,
		"y": 69
	},
	{
		"x": 46,
		"y": 69
	},
	{
		"x": 47,
		"y": 69
	},
	{
		"x": 48,
		"y": 69
	},
	{
		"x": 49,
		"y": 69
	},
	{
		"x": 50,
		"y": 69
	},
	{
		"x": 51,
		"y": 69
	},
	{
		"x": 18,
		"y": 70
	},
	{
		"x": 19,
		"y": 70
	},
	{
		"x": 20,
		"y": 70
	},
	{
		"x": 21,
		"y": 70
	},
	{
		"x": 22,
		"y": 70
	},
	{
		"x": 23,
		"y": 70
	},
	{
		"x": 24,
		"y": 70
	},
	{
		"x": 25,
		"y": 70
	},
	{
		"x": 26,
		"y": 70
	},
	{
		"x": 27,
		"y": 70
	},
	{
		"x": 28,
		"y": 70
	},
	{
		"x": 29,
		"y": 70
	},
	{
		"x": 30,
		"y": 70
	},
	{
		"x": 31,
		"y": 70
	},
	{
		"x": 32,
		"y": 70
	},
	{
		"x": 33,
		"y": 70
	},
	{
		"x": 34,
		"y": 70
	},
	{
		"x": 35,
		"y": 70
	},
	{
		"x": 36,
		"y": 70
	},
	{
		"x": 37,
		"y": 70
	},
	{
		"x": 38,
		"y": 70
	},
	{
		"x": 39,
		"y": 70
	},
	{
		"x": 40,
		"y": 70
	},
	{
		"x": 41,
		"y": 70
	},
	{
		"x": 42,
		"y": 70
	},
	{
		"x": 43,
		"y": 70
	},
	{
		"x": 44,
		"y": 70
	},
	{
		"x": 45,
		"y": 70
	},
	{
		"x": 46,
		"y": 70
	},
	{
		"x": 47,
		"y": 70
	},
	{
		"x": 48,
		"y": 70
	},
	{
		"x": 49,
		"y": 70
	},
	{
		"x": 50,
		"y": 70
	},
	{
		"x": 51,
		"y": 70
	},
	{
		"x": 52,
		"y": 70
	},
	{
		"x": 18,
		"y": 71
	},
	{
		"x": 19,
		"y": 71
	},
	{
		"x": 20,
		"y": 71
	},
	{
		"x": 21,
		"y": 71
	},
	{
		"x": 22,
		"y": 71
	},
	{
		"x": 23,
		"y": 71
	},
	{
		"x": 24,
		"y": 71
	},
	{
		"x": 25,
		"y": 71
	},
	{
		"x": 26,
		"y": 71
	},
	{
		"x": 27,
		"y": 71
	},
	{
		"x": 28,
		"y": 71
	},
	{
		"x": 29,
		"y": 71
	},
	{
		"x": 30,
		"y": 71
	},
	{
		"x": 31,
		"y": 71
	},
	{
		"x": 32,
		"y": 71
	},
	{
		"x": 33,
		"y": 71
	},
	{
		"x": 36,
		"y": 71
	},
	{
		"x": 37,
		"y": 71
	},
	{
		"x": 38,
		"y": 71
	},
	{
		"x": 39,
		"y": 71
	},
	{
		"x": 40,
		"y": 71
	},
	{
		"x": 41,
		"y": 71
	},
	{
		"x": 42,
		"y": 71
	},
	{
		"x": 43,
		"y": 71
	},
	{
		"x": 44,
		"y": 71
	},
	{
		"x": 45,
		"y": 71
	},
	{
		"x": 46,
		"y": 71
	},
	{
		"x": 47,
		"y": 71
	},
	{
		"x": 48,
		"y": 71
	},
	{
		"x": 49,
		"y": 71
	},
	{
		"x": 50,
		"y": 71
	},
	{
		"x": 51,
		"y": 71
	},
	{
		"x": 52,
		"y": 71
	},
	{
		"x": 18,
		"y": 72
	},
	{
		"x": 19,
		"y": 72
	},
	{
		"x": 20,
		"y": 72
	},
	{
		"x": 21,
		"y": 72
	},
	{
		"x": 22,
		"y": 72
	},
	{
		"x": 23,
		"y": 72
	},
	{
		"x": 24,
		"y": 72
	},
	{
		"x": 25,
		"y": 72
	},
	{
		"x": 26,
		"y": 72
	},
	{
		"x": 27,
		"y": 72
	},
	{
		"x": 28,
		"y": 72
	},
	{
		"x": 29,
		"y": 72
	},
	{
		"x": 30,
		"y": 72
	},
	{
		"x": 31,
		"y": 72
	},
	{
		"x": 32,
		"y": 72
	},
	{
		"x": 38,
		"y": 72
	},
	{
		"x": 39,
		"y": 72
	},
	{
		"x": 40,
		"y": 72
	},
	{
		"x": 41,
		"y": 72
	},
	{
		"x": 42,
		"y": 72
	},
	{
		"x": 43,
		"y": 72
	},
	{
		"x": 44,
		"y": 72
	},
	{
		"x": 45,
		"y": 72
	},
	{
		"x": 46,
		"y": 72
	},
	{
		"x": 47,
		"y": 72
	},
	{
		"x": 48,
		"y": 72
	},
	{
		"x": 49,
		"y": 72
	},
	{
		"x": 50,
		"y": 72
	},
	{
		"x": 51,
		"y": 72
	},
	{
		"x": 52,
		"y": 72
	},
	{
		"x": 17,
		"y": 73
	},
	{
		"x": 18,
		"y": 73
	},
	{
		"x": 19,
		"y": 73
	},
	{
		"x": 20,
		"y": 73
	},
	{
		"x": 21,
		"y": 73
	},
	{
		"x": 22,
		"y": 73
	},
	{
		"x": 23,
		"y": 73
	},
	{
		"x": 24,
		"y": 73
	},
	{
		"x": 25,
		"y": 73
	},
	{
		"x": 26,
		"y": 73
	},
	{
		"x": 27,
		"y": 73
	},
	{
		"x": 28,
		"y": 73
	},
	{
		"x": 29,
		"y": 73
	},
	{
		"x": 30,
		"y": 73
	},
	{
		"x": 31,
		"y": 73
	},
	{
		"x": 39,
		"y": 73
	},
	{
		"x": 40,
		"y": 73
	},
	{
		"x": 41,
		"y": 73
	},
	{
		"x": 42,
		"y": 73
	},
	{
		"x": 43,
		"y": 73
	},
	{
		"x": 44,
		"y": 73
	},
	{
		"x": 45,
		"y": 73
	},
	{
		"x": 46,
		"y": 73
	},
	{
		"x": 47,
		"y": 73
	},
	{
		"x": 48,
		"y": 73
	},
	{
		"x": 49,
		"y": 73
	},
	{
		"x": 50,
		"y": 73
	},
	{
		"x": 51,
		"y": 73
	},
	{
		"x": 52,
		"y": 73
	},
	{
		"x": 53,
		"y": 73
	},
	{
		"x": 17,
		"y": 74
	},
	{
		"x": 18,
		"y": 74
	},
	{
		"x": 19,
		"y": 74
	},
	{
		"x": 20,
		"y": 74
	},
	{
		"x": 21,
		"y": 74
	},
	{
		"x": 22,
		"y": 74
	},
	{
		"x": 23,
		"y": 74
	},
	{
		"x": 24,
		"y": 74
	},
	{
		"x": 25,
		"y": 74
	},
	{
		"x": 26,
		"y": 74
	},
	{
		"x": 27,
		"y": 74
	},
	{
		"x": 28,
		"y": 74
	},
	{
		"x": 29,
		"y": 74
	},
	{
		"x": 41,
		"y": 74
	},
	{
		"x": 42,
		"y": 74
	},
	{
		"x": 43,
		"y": 74
	},
	{
		"x": 44,
		"y": 74
	},
	{
		"x": 45,
		"y": 74
	},
	{
		"x": 46,
		"y": 74
	},
	{
		"x": 47,
		"y": 74
	},
	{
		"x": 48,
		"y": 74
	},
	{
		"x": 49,
		"y": 74
	},
	{
		"x": 50,
		"y": 74
	},
	{
		"x": 51,
		"y": 74
	},
	{
		"x": 52,
		"y": 74
	},
	{
		"x": 53,
		"y": 74
	},
	{
		"x": 17,
		"y": 75
	},
	{
		"x": 18,
		"y": 75
	},
	{
		"x": 19,
		"y": 75
	},
	{
		"x": 20,
		"y": 75
	},
	{
		"x": 21,
		"y": 75
	},
	{
		"x": 22,
		"y": 75
	},
	{
		"x": 23,
		"y": 75
	},
	{
		"x": 24,
		"y": 75
	},
	{
		"x": 25,
		"y": 75
	},
	{
		"x": 26,
		"y": 75
	},
	{
		"x": 27,
		"y": 75
	},
	{
		"x": 28,
		"y": 75
	},
	{
		"x": 42,
		"y": 75
	},
	{
		"x": 43,
		"y": 75
	},
	{
		"x": 44,
		"y": 75
	},
	{
		"x": 45,
		"y": 75
	},
	{
		"x": 46,
		"y": 75
	},
	{
		"x": 47,
		"y": 75
	},
	{
		"x": 48,
		"y": 75
	},
	{
		"x": 49,
		"y": 75
	},
	{
		"x": 50,
		"y": 75
	},
	{
		"x": 51,
		"y": 75
	},
	{
		"x": 52,
		"y": 75
	},
	{
		"x": 53,
		"y": 75
	},
	{
		"x": 16,
		"y": 76
	},
	{
		"x": 17,
		"y": 76
	},
	{
		"x": 18,
		"y": 76
	},
	{
		"x": 19,
		"y": 76
	},
	{
		"x": 20,
		"y": 76
	},
	{
		"x": 21,
		"y": 76
	},
	{
		"x": 22,
		"y": 76
	},
	{
		"x": 23,
		"y": 76
	},
	{
		"x": 24,
		"y": 76
	},
	{
		"x": 25,
		"y": 76
	},
	{
		"x": 26,
		"y": 76
	},
	{
		"x": 27,
		"y": 76
	},
	{
		"x": 43,
		"y": 76
	},
	{
		"x": 44,
		"y": 76
	},
	{
		"x": 45,
		"y": 76
	},
	{
		"x": 46,
		"y": 76
	},
	{
		"x": 47,
		"y": 76
	},
	{
		"x": 48,
		"y": 76
	},
	{
		"x": 49,
		"y": 76
	},
	{
		"x": 50,
		"y": 76
	},
	{
		"x": 51,
		"y": 76
	},
	{
		"x": 52,
		"y": 76
	},
	{
		"x": 53,
		"y": 76
	},
	{
		"x": 54,
		"y": 76
	},
	{
		"x": 16,
		"y": 77
	},
	{
		"x": 17,
		"y": 77
	},
	{
		"x": 18,
		"y": 77
	},
	{
		"x": 19,
		"y": 77
	},
	{
		"x": 20,
		"y": 77
	},
	{
		"x": 21,
		"y": 77
	},
	{
		"x": 22,
		"y": 77
	},
	{
		"x": 23,
		"y": 77
	},
	{
		"x": 24,
		"y": 77
	},
	{
		"x": 25,
		"y": 77
	},
	{
		"x": 45,
		"y": 77
	},
	{
		"x": 46,
		"y": 77
	},
	{
		"x": 47,
		"y": 77
	},
	{
		"x": 48,
		"y": 77
	},
	{
		"x": 49,
		"y": 77
	},
	{
		"x": 50,
		"y": 77
	},
	{
		"x": 51,
		"y": 77
	},
	{
		"x": 52,
		"y": 77
	},
	{
		"x": 53,
		"y": 77
	},
	{
		"x": 54,
		"y": 77
	},
	{
		"x": 16,
		"y": 78
	},
	{
		"x": 17,
		"y": 78
	},
	{
		"x": 18,
		"y": 78
	},
	{
		"x": 19,
		"y": 78
	},
	{
		"x": 20,
		"y": 78
	},
	{
		"x": 21,
		"y": 78
	},
	{
		"x": 22,
		"y": 78
	},
	{
		"x": 23,
		"y": 78
	},
	{
		"x": 24,
		"y": 78
	},
	{
		"x": 46,
		"y": 78
	},
	{
		"x": 47,
		"y": 78
	},
	{
		"x": 48,
		"y": 78
	},
	{
		"x": 49,
		"y": 78
	},
	{
		"x": 50,
		"y": 78
	},
	{
		"x": 51,
		"y": 78
	},
	{
		"x": 52,
		"y": 78
	},
	{
		"x": 53,
		"y": 78
	},
	{
		"x": 54,
		"y": 78
	},
	{
		"x": 16,
		"y": 79
	},
	{
		"x": 17,
		"y": 79
	},
	{
		"x": 18,
		"y": 79
	},
	{
		"x": 19,
		"y": 79
	},
	{
		"x": 20,
		"y": 79
	},
	{
		"x": 21,
		"y": 79
	},
	{
		"x": 22,
		"y": 79
	},
	{
		"x": 23,
		"y": 79
	},
	{
		"x": 47,
		"y": 79
	},
	{
		"x": 48,
		"y": 79
	},
	{
		"x": 49,
		"y": 79
	},
	{
		"x": 50,
		"y": 79
	},
	{
		"x": 51,
		"y": 79
	},
	{
		"x": 52,
		"y": 79
	},
	{
		"x": 53,
		"y": 79
	},
	{
		"x": 54,
		"y": 79
	},
	{
		"x": 55,
		"y": 79
	},
	{
		"x": 15,
		"y": 80
	},
	{
		"x": 16,
		"y": 80
	},
	{
		"x": 17,
		"y": 80
	},
	{
		"x": 18,
		"y": 80
	},
	{
		"x": 19,
		"y": 80
	},
	{
		"x": 20,
		"y": 80
	},
	{
		"x": 21,
		"y": 80
	},
	{
		"x": 49,
		"y": 80
	},
	{
		"x": 50,
		"y": 80
	},
	{
		"x": 51,
		"y": 80
	},
	{
		"x": 52,
		"y": 80
	},
	{
		"x": 53,
		"y": 80
	},
	{
		"x": 54,
		"y": 80
	},
	{
		"x": 55,
		"y": 80
	},
	{
		"x": 15,
		"y": 81
	},
	{
		"x": 16,
		"y": 81
	},
	{
		"x": 17,
		"y": 81
	},
	{
		"x": 18,
		"y": 81
	},
	{
		"x": 19,
		"y": 81
	},
	{
		"x": 20,
		"y": 81
	},
	{
		"x": 50,
		"y": 81
	},
	{
		"x": 51,
		"y": 81
	},
	{
		"x": 52,
		"y": 81
	},
	{
		"x": 53,
		"y": 81
	},
	{
		"x": 54,
		"y": 81
	},
	{
		"x": 55,
		"y": 81
	},
	{
		"x": 15,
		"y": 82
	},
	{
		"x": 16,
		"y": 82
	},
	{
		"x": 17,
		"y": 82
	},
	{
		"x": 18,
		"y": 82
	},
	{
		"x": 19,
		"y": 82
	},
	{
		"x": 51,
		"y": 82
	},
	{
		"x": 52,
		"y": 82
	},
	{
		"x": 53,
		"y": 82
	},
	{
		"x": 54,
		"y": 82
	},
	{
		"x": 55,
		"y": 82
	},
	{
		"x": 14,
		"y": 83
	},
	{
		"x": 15,
		"y": 83
	},
	{
		"x": 16,
		"y": 83
	},
	{
		"x": 17,
		"y": 83
	},
	{
		"x": 18,
		"y": 83
	},
	{
		"x": 53,
		"y": 83
	},
	{
		"x": 54,
		"y": 83
	},
	{
		"x": 55,
		"y": 83
	},
	{
		"x": 56,
		"y": 83
	},
	{
		"x": 14,
		"y": 84
	},
	{
		"x": 15,
		"y": 84
	},
	{
		"x": 16,
		"y": 84
	},
	{
		"x": 54,
		"y": 84
	},
	{
		"x": 55,
		"y": 84
	},
	{
		"x": 56,
		"y": 84
	},
	{
		"x": 14,
		"y": 85
	},
	{
		"x": 15,
		"y": 85
	},
	{
		"x": 55,
		"y": 85
	},
	{
		"x": 56,
		"y": 85
	},
	{
		"x": 13,
		"y": 86
	},
	{
		"x": 57,
		"y": 86
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/line_image_positions.json
 ** module id = 212
 ** module chunks = 0
 **/